<template>
  <v-tooltip
      bottom
      color="primary"
      open-delay="300"
      :open-on-click="false"
      :open-on-focus="false"
      :open-on-hover="true"
  >
    <template v-slot:activator="{ on, attrs }">
        <v-icon
            v-if="warning != null"
            v-bind="attrs"
            v-on="on"
        >
          mdi-alert-circle
        </v-icon>
    </template>
      <span>{{ warning }}</span>
  </v-tooltip>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {mapFields} from "vuex-map-fields";

export default {
  name: 'BatchRunWarning',
  props: ['warning',],

  data() {
    return {
      hover: false,
    }
  },

  components: {},

  computed: {
  },

  methods: {
  },

  mounted() {
  },
}
</script>

<style scoped lang="scss">
.hover-badge {
  z-index: 2;
}
</style>